module.exports = __webpack_public_path__ + "img/btn_menu-close.1159a4eb.png";